import React, { useCallback, useEffect, useState } from "react";
import { Button, Fade, Modal, Backdrop } from "@material-ui/core";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";
import { injected, walletconnect } from "../../../utils/web3Connectors";
import MetamaskLogo from "../../../assets/images/MetamaskLogo.png";
import walletConnectIcon from "../../../assets/images/walletConnect.png";
import useStyles from "./connectWalletModalStyles.js";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import {
  InjectedConnector,
  NoEthereumProviderError,
  UserRejectedRequestError,
} from "@web3-react/injected-connector";
import { toast } from "react-toastify";
import Notify from "../../Toast/Notify";
import { supportedChains } from "../../../contract/constant";
import { useEagerConnect, useInactiveListener } from "../../../hooks/walletConnectHooks";
import {isMobile} from "react-device-detect";

function ConnectWalletModal({ open, handleOpen, handleClose, key }) {
  const toastId = React.useRef(null);
  const classes = useStyles();
  const { account, active, connector, deactivate, library, chainId, activate } =
    useWeb3React();
  const web3context = useWeb3React();


  const triedEager = useEagerConnect();

  useInactiveListener(!triedEager)
  useEffect(()=>{
    if(window.localStorage.getItem("previousWallet") =="metaMask"){
      reActivateWallet(injected);
    }
    else if(window.localStorage.getItem("previousWallet") =="walletConnect")
    {
      reActivateWallet(walletconnect);
    }
  },[account, chainId])

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

  const getErrorMessage = (e) => {
    if (e instanceof UnsupportedChainIdError) {
      return "You are connected to wrong network, Connect to Ethereum or Binance smart chain.";
    } else if (e instanceof NoEthereumProviderError) {
      return (
        <span>
          {" "}
          No Wallet Found please install{" "}
          <a
            href={(isMobile)?getMobileOperatingSystem()=="Android"?"https://play.google.com/store/apps/details?id=io.metamask&hl=en&gl=US":"https://apps.apple.com/us/app/metamask-blockchain-wallet/id1438144202":typeof InstallTrigger !== 'undefined'?"https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search":"https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en"}
            target="_blank"
          >
            Metamask
          </a>{" "}
        </span>
      );
    } else if (e instanceof UserRejectedRequestError) {
      return "Wallet Connection Rejected, Try Again!";
    }else if (e.code === -32002) {
      return "Wallet Connection Request Pending";
    } else {
      return "An Error Occurred ";
    }
  };
  const reActivateWallet = useCallback(
    async (connector, onClose = () => {}) => {
      if (
        connector &&
        connector instanceof WalletConnectConnector 
        // connector.walletConnectProvider?.wc?.uri
        ) {
          connector.walletConnectProvider = undefined
        }
        try {
        let result = await web3context.activate(
          connector
            ? connector
            : new InjectedConnector({
                // supportedChainIds: [1, 4],
                supportedChainIds: supportedChains,
              }),
          undefined,
          true
        ).then(result=>{
          if(connector instanceof WalletConnectConnector){
            window.localStorage.setItem("previousWallet", "walletConnect");
          }
          else{
            window.localStorage.setItem("previousWallet", "metaMask");
          }
        })

        handleClose();

      } catch (e) {
        // window.localStorage.setItem("previousWallet", "");
    }
    },
    [web3context]
  );
  const activateWallet = useCallback(
    async (connector, onClose = () => {}) => {
      if (
        connector &&
        connector instanceof WalletConnectConnector 
        // connector.walletConnectProvider?.wc?.uri
        ) {
          connector.walletConnectProvider = undefined
        }
        try {
        let result = await web3context.activate(
          connector
            ? connector
            : new InjectedConnector({
                // supportedChainIds: [1, 4],
                supportedChainIds: supportedChains,
              }),
          undefined,
          true
        ).then(result=>{
          if(connector instanceof WalletConnectConnector){
            window.localStorage.setItem("previousWallet", "walletConnect");
          }
          else{
            window.localStorage.setItem("previousWallet", "metaMask");
          }
        })

        handleClose();
        if(localStorage.getItem("previousWallet")){
          toast(<Notify text={"Wallet Connected Successfully"} severity="success" />, {
            position: "bottom-right",
            toastId:"connectSuccessfull"
          });
        }
        // window.localStorage.setItem("previousWallet", "metaMask");
      } catch (e) {
        // window.localStorage.setItem("previousWallet", ""); 
        window.localStorage.removeItem("previousWallet");
        // await connector.close();
        console.log("hello error: ", e.message)
        
        if(e.message != "The user rejected the request."){
        const err = getErrorMessage(e);
        if (e.code == 4001) {
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:version"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:session:id"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:session:secret"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:session:linked"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:walletUsername"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:DefaultChainId"
          );
          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:Addresses"
          );

          window.localStorage.removeItem(
            "-walletlink:https://www.walletlink.org:IsStandaloneSigning"
          );
        }

        // if ( !(e instanceof UnsupportedChainIdError)) {  
        if(!toast.isActive(toastId.current)) {
          // toast.update(toastId, {
          //   autoClose: 5000
          // });
          // toastId.current = toast(<Notify text={err} severity="error" />, {
          //   position: "bottom-right",
          //   autoClose:5000
          // });
          toast(
            <Notify text={err} severity="error" />
            ,
            {
              position: "bottom-right",
              toastId:"connectSuccessfull"
            }
          );
        // }   
      }}
    }
    },
    [web3context]
  );
  const connectWalletMetamask = async () => {
      if (!(connector instanceof InjectedConnector)) {
        activateWallet(injected);
      } else {
        if(!toast.isActive(toastId.current)) {
          toast.update(toastId, {
            autoClose: 5000
          });
          toastId.current = toast(<Notify text={"You are on the wrong network, Connect to Ethereum or Bianance network."} severity="error" />, {
            position: "bottom-right",
            autoClose:5000
          });
        
      }
    } 
    // else {
    //   if(!toast.isActive(toastId.current)) {
    //     toast.update(toastId, {
    //       autoClose: 5000
    //     });
    //     toastId.current = toast(<Notify text={"You are connected to wrong network 😔, Connect to Ethereum Mainnet or Bianance Smart Chain."} severity="error" />, {
    //       position: "bottom-right",
    //       autoClose:5000
    //     });
    //   }  
    // }

  };

  const deactivateWallet = async () => {
    window.localStorage.removeItem("previousWallet");
    await deactivate();
    if (connector instanceof WalletConnectConnector) {
      await connector.close();
    }
    if(connector instanceof InjectedConnector){
      await connector.deactivate();
    }

    setTimeout(() => {
    // return true
    return true
      // dispatch({ type: LOCAL_TYPES.DISCONNECT_USER });
    }, 1000);
   
  };
  const deactivateMetamaskWallet = async () => {
    window.localStorage.removeItem("previousWallet");
    await deactivate();
    if(connector instanceof InjectedConnector){
      await connector.deactivate();
    }

    setTimeout(() => {
    // return true
    return true
      // dispatch({ type: LOCAL_TYPES.DISCONNECT_USER });
    }, 1000);
   
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div>
              <div className={classes.connectWallet}>
                <div className={classes.connectWalletText}>Connect Wallet</div>
                <div onClick={handleClose}>
                  <img src={CloseIcon} className={classes.closeIcon} />
                </div>
              </div>
              <div className={classes.walletList}>
                <div
                  className={`${classes.walletItem} ${(window.localStorage.getItem("previousWallet")=="metaMask")&&classes.selectedWallet}`}
                  onClick={async ()=>{
                    await deactivate();
                    await deactivateMetamaskWallet();
                    // if (!active) {
                      if (!(connector instanceof InjectedConnector)) {
                        await activateWallet(injected);
                      // }
                    } 
                   
                  }}
                >
                  <div className={classes.WalletTitle}>Metamask</div>
                  <div className={classes.WalletIcon}>
                    <img src={MetamaskLogo} className={classes.connectModalWalletIcon}/>
                  </div>
                </div>
                <div className={`${classes.walletItem} ${(window.localStorage.getItem("previousWallet")=="walletConnect")&&classes.selectedWallet}`}
                   onClick={async () => {
                     await deactivate();
                     await deactivateWallet();
                      window.localStorage.setItem(
                         "previousWallet",
                         "walletConnect"
                       );
                      // if (
                      //   connector &&
                      //   connector instanceof WalletConnectConnector
                      //   // connector.walletConnectProvider?.wc?.uri
                      // ) {
                        let flag = true;
                        if(localStorage.getItem("previousWallet") != ""){
                          await activateWallet(walletconnect)
                          flag = false;
                        }
                        if(flag){
                          connector.walletConnectProvider = undefined
                          await activateWallet(walletconnect);
                        }
                        // }
                        //  if(!active &&
                        //  !(connector instanceof WalletConnectConnector)){
                      //  }
   
        
                      
                  }} >
                  <div className={classes.WalletTitle}>Wallet Connect</div>
                  <div className={classes.WalletIcon}>
                  <img src={walletConnectIcon} className={classes.connectModalWalletIcon}/>
                  </div>
                </div>
                {/* <div className={classes.walletItem} onClick={deactivateWallet}>
                  <div className={classes.WalletTitle}>deactivate</div>
                  <div className={classes.WalletIcon}>
                    <img src={MetamaskLogo} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default ConnectWalletModal;
